<script setup lang="ts"></script>

<template>
    <section class="usp-bar container container--lg">
        <div class="usp">
            <figure>🔥</figure>
            <h2><em>Super Jackpots</em>Vokser mens du spiller</h2>
        </div>
        <span class="usp-divider" />
        <div class="usp">
            <figure>⚡</figure>
            <h2><em>Express Udbetaling</em>Gevinster ud. Hurtigt.</h2>
        </div>
        <span class="usp-divider" />
        <div class="usp">
            <figure>🎁</figure>
            <h2><em>Fede Bonusser</em>Uden dikkedarer</h2>
        </div>
    </section>
</template>

<style scoped lang="scss">
.usp-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px 0;
    margin: 0 auto;

    @media (min-width: $screen-md) {
        padding: 22px 0;
    }

    .usp {
        width: 33.333%;
        display: flex;
        justify-content: center;
        align-items: baseline;

        @media (min-width: $screen-md) {
            min-height: 40px;
        }

        figure {
            margin: 0;
            padding: 0 3px 0 0;
            font-size: 14px;

            @media (min-width: $screen-md) {
                font-size: 18px;
            }
        }

        h2 {
            font-family: $brand-font-family;
            font-weight: 800;
            margin: 0;

            font-size: 2.8vw;
            font-size: clamp(9px, 2.8vw, 12px);

            @media (min-width: $screen-md) {
                font-size: 14px;
            }
        }

        em {
            display: block;
            color: #fed634;

            font-size: 3.9vw;
            font-size: clamp(12px, 3.9vw, 16px);
            font-style: normal;

            @media (min-width: $screen-md) {
                font-size: 20px;
            }
        }
    }

    .usp-divider {
        border-style: solid;
        border-color: rgb(255 255 255 / 10%);
        border-width: 0 1px 0 0;
        height: 42px;
    }
}
</style>
